(() => {
  const STORAGE_KEY = 'dkgWishlistV1';
  const TYPES = ['product', 'recipe'];

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
      return TYPES.reduce((wishlist, type) => {
        wishlist[type] = Array.isArray(parsed[type]) ? parsed[type] : [];
        return wishlist;
      }, {});
    } catch (error) {
      return { product: [], recipe: [] };
    }
  };

  const writeWishlist = (wishlist) => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
  };

  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>"']/g, (character) => {
      const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      };

      return entities[character];
    });

  const heartIcon = `
    <span class="svg-wrapper" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-heart" viewBox="0 0 24 24">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
    </span>
  `;

  const getButtonItem = (button) => ({
    id: button.dataset.wishlistId,
    type: button.dataset.wishlistType,
    title: button.dataset.wishlistTitle,
    url: button.dataset.wishlistUrl,
    image: button.dataset.wishlistImage,
    meta: button.dataset.wishlistMeta,
    productHandle: button.dataset.wishlistProductHandle,
    variantId: button.dataset.wishlistVariantId,
    variantsCount: Number(button.dataset.wishlistVariantsCount || 0),
    available: button.dataset.wishlistAvailable !== 'false',
  });

  const hasItem = (wishlist, type, id) => wishlist[type]?.some((item) => item.id === id);

  const getProductHandle = (item) => {
    if (item.productHandle) return item.productHandle;
    const match = String(item.url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  };

  const updateSavedProduct = (handle, updates) => {
    if (!handle) return;

    const wishlist = readWishlist();
    wishlist.product = wishlist.product.map((item) => {
      if (getProductHandle(item) !== handle) return item;
      return { ...item, productHandle: handle, ...updates };
    });
    writeWishlist(wishlist);
  };

  const removeItem = (type, id) => {
    if (!TYPES.includes(type) || !id) return;

    const wishlist = readWishlist();
    wishlist[type] = wishlist[type].filter((item) => item.id !== id);
    writeWishlist(wishlist);
    syncButtons();
    renderAccountWishlist();
  };

  const addVariantToCart = async (variantId, button) => {
    if (!variantId) return;

    button.classList.add('is-loading');
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId, quantity: 1,
          ...(button.dataset.productHandle === 'adventskalender'
            ? { properties: { Versand: 'Gesamte Bestellung ab Anfang November' } } : {})
        }),
      });

      if (!response.ok) throw new Error('Add failed');

      if (typeof window.dkgOpenCartDrawer === 'function') {
        await window.dkgOpenCartDrawer();
      }
    } catch (error) {
      button.textContent = 'Fehler';
      setTimeout(() => {
        button.textContent = button.dataset.defaultText || 'In den Warenkorb';
      }, 1600);
    } finally {
      button.classList.remove('is-loading');
      button.disabled = false;
    }
  };

  const openQuickAdd = (handle) => {
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'quick-add-trigger';
    trigger.dataset.productHandle = handle;
    trigger.hidden = true;
    document.body.appendChild(trigger);
    trigger.click();
    trigger.remove();
  };

  const syncButtons = () => {
    const wishlist = readWishlist();

    document.querySelectorAll('[data-dkg-wishlist-button]').forEach((button) => {
      const { type, id } = getButtonItem(button);
      const active = Boolean(type && id && hasItem(wishlist, type, id));
      button.setAttribute('aria-pressed', String(active));
    });
  };

  const toggleItem = (button) => {
    const item = getButtonItem(button);
    if (!item.type || !item.id || !TYPES.includes(item.type)) return;

    const wishlist = readWishlist();
    const items = wishlist[item.type] || [];
    const existing = items.findIndex((savedItem) => savedItem.id === item.id);

    if (existing >= 0) {
      items.splice(existing, 1);
    } else {
      items.unshift(item);
    }

    wishlist[item.type] = items;
    writeWishlist(wishlist);
    syncButtons();
    renderAccountWishlist();
  };

  const renderProductAction = (item) => {
    const productHandle = getProductHandle(item);

    if (item.available === false) {
      return '<span class="dkg-wishlist-account__soldout">Ausverkauft</span>';
    }

    if (productHandle) {
      const label = item.variantsCount > 1 ? 'Auswählen' : 'In den Warenkorb';
      return `
        <button
          class="dkg-wishlist-account__cart"
          type="button"
          data-dkg-wishlist-product-add
          data-product-handle="${escapeHtml(
          productHandle
        )}"
          data-variant-id="${escapeHtml(item.variantId || '')}"
          data-variants-count="${escapeHtml(item.variantsCount || '')}"
          data-default-text="${escapeHtml(label)}"
        >
          ${escapeHtml(label)}
        </button>
      `;
    }

    return '';
  };

  const renderProductCard = (item) => `
    <article class="dkg-wishlist-account__item dkg-wishlist-account__item--product">
      <button
        class="dkg-wishlist-button dkg-wishlist-account__remove"
        type="button"
        data-dkg-wishlist-remove
        data-wishlist-type="product"
        data-wishlist-id="${escapeHtml(item.id)}"
        aria-label="${escapeHtml(item.title)} aus der Merkliste entfernen"
        aria-pressed="true"
      >
        ${heartIcon}
      </button>
      <a class="dkg-wishlist-account__product-link" href="${escapeHtml(item.url)}">
        <span class="dkg-wishlist-account__product-media">
          ${
            item.image
              ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
              : ''
          }
        </span>
        <span class="dkg-wishlist-account__product-info">
          <span class="dkg-wishlist-account__item-title">${escapeHtml(item.title)}</span>
          ${
            item.meta
              ? `<span class="dkg-wishlist-account__item-meta">${escapeHtml(item.meta)}</span>`
              : ''
          }
        </span>
      </a>
      ${renderProductAction(item)}
    </article>
  `;

  const renderRecipeCard = (item) => `
    <article class="dkg-wishlist-recipe-card">
      <button
        class="dkg-wishlist-button dkg-wishlist-account__remove dkg-wishlist-account__remove--recipe"
        type="button"
        data-dkg-wishlist-remove
        data-wishlist-type="recipe"
        data-wishlist-id="${escapeHtml(item.id)}"
        aria-label="${escapeHtml(item.title)} aus der Merkliste entfernen"
        aria-pressed="true"
      >
        ${heartIcon}
      </button>
      <a class="dkg-wishlist-recipe-card__link" href="${escapeHtml(item.url)}">
        <span class="dkg-wishlist-recipe-card__image">
          ${
            item.image
              ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
              : ''
          }
          ${
            item.meta
              ? `<span class="dkg-wishlist-recipe-card__badge">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="12" r="9"></circle>
                    <polyline points="12 7 12 12 15 14"></polyline>
                  </svg>
                  <span>${escapeHtml(item.meta)}</span>
                </span>`
              : ''
          }
        </span>
        <span class="dkg-wishlist-recipe-card__content">
          <span class="dkg-wishlist-recipe-card__title">${escapeHtml(item.title)}</span>
        </span>
      </a>
    </article>
  `;

  const renderItems = (items, type) => {
    if (!items.length) {
      const emptyText =
        type === 'product'
          ? 'Du hast noch keine Produkte gespeichert. Stöbere durch unsere Gewürze, Öle und Feinkost und speichere deine Favoriten mit dem Herzsymbol.'
          : 'Du hast noch keine Rezepte gespeichert. Speichere dir schnelle Rezeptideen für später und finde sie hier jederzeit wieder.';
      const emptyLink = type === 'product' ? '/collections/all' : '/pages/rezepte';
      const emptyLabel = type === 'product' ? 'Produkte entdecken' : 'Rezepte entdecken';

      return `
        <div class="dkg-wishlist-empty-state">
          <p>${escapeHtml(emptyText)}</p>
          <a href="${escapeHtml(emptyLink)}">${escapeHtml(emptyLabel)}</a>
        </div>
      `;
    }

    return `
      <div class="dkg-wishlist-account__grid dkg-wishlist-account__grid--${escapeHtml(type)}">
        ${items
          .map((item) => (type === 'recipe' ? renderRecipeCard(item) : renderProductCard(item)))
          .join('')}
      </div>
    `;
  };

  const renderAccountWishlist = () => {
    const container = document.querySelector('[data-dkg-wishlist-account]');
    if (!container) return;

    const wishlist = readWishlist();
    container.innerHTML = `
      <div class="dkg-wishlist-account__group">
        <div class="dkg-wishlist-account__group-header">
          <h3>Produkte</h3>
          <p>Deine gespeicherten Lieblinge aus dem Shop.</p>
        </div>
        ${renderItems(wishlist.product, 'product')}
      </div>
      <div class="dkg-wishlist-account__group dkg-wishlist-account__group--recipe">
        <div class="dkg-wishlist-account__group-header">
          <h3>Rezepte</h3>
          <p>Ideen, die du dir für später aufgehoben hast.</p>
        </div>
        ${renderItems(wishlist.recipe, 'recipe')}
      </div>
    `;
  };

  const hasWishlistUi = () =>
    Boolean(document.querySelector('[data-dkg-wishlist-button], [data-dkg-wishlist-account]'));

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dkg-wishlist-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    toggleItem(button);
  });

  document.addEventListener('click', async (event) => {
    const removeButton = event.target.closest('[data-dkg-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      removeItem(removeButton.dataset.wishlistType, removeButton.dataset.wishlistId);
      return;
    }

    const button = event.target.closest('[data-dkg-wishlist-product-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;
    const variantId = button.dataset.variantId;
    const variantsCount = Number(button.dataset.variantsCount || 0);

    if (variantsCount > 1 && handle) {
      openQuickAdd(handle);
      return;
    }

    if (variantId) {
      await addVariantToCart(variantId, button);
      return;
    }

    if (!handle) return;

    button.classList.add('is-loading');
    button.disabled = true;

    try {
      const product = await fetch(`/products/${handle}.js`).then((response) => response.json());
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const availableVariants = variants.filter((variant) => variant.available);

      updateSavedProduct(handle, {
        variantsCount: variants.length,
        variantId: variants.length === 1 ? String(variants[0].id) : '',
        available: availableVariants.length > 0,
      });

      if (variants.length === 1 && variants[0].available) {
        button.dataset.variantId = String(variants[0].id);
        await addVariantToCart(variants[0].id, button);
      } else if (variants.length > 1) {
        openQuickAdd(handle);
      } else {
        button.textContent = 'Ausverkauft';
      }
    } catch (error) {
      button.textContent = 'Fehler';
      setTimeout(() => {
        button.textContent = button.dataset.defaultText || 'In den Warenkorb';
      }, 1600);
    } finally {
      button.classList.remove('is-loading');
      button.disabled = false;
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (!hasWishlistUi()) return;

    syncButtons();
    renderAccountWishlist();
  });

  document.addEventListener('shopify:section:load', () => {
    if (!hasWishlistUi()) return;

    syncButtons();
    renderAccountWishlist();
  });
})();
